import TextBubbles from '@home/components/TextBubbles';
import { idKeyNameMap } from '@op/constants/page';
import useTabHistory from '@op/hooks/useTabHistory';
import { getReportMenuTab } from '@op/services';
import React, { useEffect, useMemo, useState } from 'react';
import { getLocale, useIntl } from 'umi';

/**
menu_tab接口
当菜单有report_id ="" 时传page_id;  其他页面使用pageId
当菜单report_id !="" 时传menu_id;   CustomizeReport页面使用menuId
 */
export default function useReportMenuTab({
  gameInfo,
  menuId,
  name = '',
  sourceType,
  defaultId,
  defaultLoading = true,
}: {
  gameInfo: any;
  menuId: string;
  name?: string;
  sourceType: string;
  defaultId?: string;
  defaultLoading?: boolean;
}) {
  const [loading, setLoading] = useState<boolean>(defaultLoading);
  const [data, setData] = useState([]);
  const { onActive, tab } = useTabHistory<string>({
    defaultValue: defaultId,
    removeKeys: ['start_time', 'end_time'],
  });
  const { formatMessage } = useIntl();

  function JSONParse(str: string) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return null;
    }
  }

  useEffect(() => {
    const key = idKeyNameMap[sourceType];
    if (!gameInfo.edition_unified_id) return;
    if (!key) return;
    setLoading(true);
    getReportMenuTab({
      [key]: Number(menuId),
      edition_unified_id: gameInfo.edition_unified_id,
    })
      .then((value: any) => {
        const data = value || [];
        data?.sort((a, b) => a.sort - b.sort);
        setData(data);
        const findItem = data.find(
          (item: any) => String(item.id) === defaultId,
        );
        if (!findItem) {
          data?.[0] && onActive({ id: String(data?.[0]?.id) });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [gameInfo, menuId, name, sourceType]);

  const tabs = useMemo(() => {
    const isEn = getLocale() === 'en-US';
    return (data || [])?.map((val: any) => {
      const { id, business_type, name_en, name_cn, ext_params, children } = val;
      const ext: any = JSONParse(ext_params);
      return {
        id: String(id),
        name_cn,
        name_en,
        business_type,
        label: (
          <div className={'dbo-channellabel'}>
            <TextBubbles
              rowNum={1}
              className={`dbo-channellabel-text`}
              text={isEn ? name_en : name_cn || name_en}
            />
          </div>
        ),
        ext,
        children: (children || []).map((val: any) => {
          const { name_en, name_cn, ext_params, id } = val;
          const ext: any = JSONParse(ext_params);
          return {
            id: String(id),
            name_en,
            name_cn: name_cn || name_en,
            url: ext?.report_url,
            date: ext?.date,
            ext,
          };
        }),
      };
    });
  }, [data, formatMessage]);

  return {
    tabs,
    loading,
    activeId: tab,
    setActiveId: (value: string) => onActive({ id: value }),
  };
}
